import Model from './model';

export default Model.extend( {

    defaults() {
        return {
            value: undefined,
            access_rule: {},
        };
    },

    computeds: {

        role: {
            set(value) {
                const {id, ...accessRule} = this.get( 'access_rule' );
                if (!+value)
                    accessRule.role = null;
                else {
                    accessRule.role = { id: +value };
                    accessRule.user = null;
                }

                return { access_rule: accessRule, salt: Math.random(), };
            },

            get() {
                const {role} =  this.get( 'access_rule' );
                return !!role ? role.id : null;
            },
        },

        organization_id: {
            set(value) {
                const {id, ...accessRule} = this.get( 'access_rule' );
                if (!value) {
                    accessRule.organization = null;
                    accessRule.user = null;
                } else {
                    accessRule.organization = { id: +value };
                    accessRule.user = null;
                }

                return { access_rule: accessRule, salt: Math.random(), };
            },

            get() {
                const {organization} = this.get( 'access_rule' );
                return !!organization ? organization.id : 0;
            },
        },

        user_id_name: {
            set(value) {
                const {id, ...accessRule} = this.get( 'access_rule' );
                if (!value || !value.id)
                    accessRule.user = null;
                else {
                    const {id, name} = value;
                    accessRule.user = { id, fio: name };
                    accessRule.role = null;
                }

                return { access_rule: accessRule, salt: Math.random(), };
            },

            get() {
                const {user} = this.get( 'access_rule' );
                if (!user) return null;
                const {id, fio = ''} = user;
                return { id, name: fio };
            },
        },

        states: {
            set(value) {
                const {id, ...accessRule} = this.get( 'access_rule' );
                if (!value)
                    accessRule.state_rule = null;
                else
                    accessRule.state_rule = { states: value };

                return { access_rule: { ...accessRule }, salt: Math.random(), };
            },

            get() {
                const {state_rule} = this.get( 'access_rule' );
                return !!state_rule ? (state_rule.states || []) : [];
            },
        },

    },

} );


// WEBPACK FOOTER //
// ./src/js/model/config.possible.value.js